module.exports = " <section> <div v-if=basket> <basket-list v-for=\"group in basket.Files\" :content=group :title=group.Name></basket-list> <basket-list :content=[] title=\"Basket is empty\" v-if=!basket.Files.length></basket-list> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/basket/Basket.vue
// module id = 179
// module chunks = 0